"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _app = require("@package/app");

var _utils = require("@package/utils");

var _profile = require("@widget/profile");

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var events = new _utils.Events();
exports.events = events;

function Widget() {
  try {
    var handleOpen = function handleOpen() {
      setOpen(true);
    };

    var handleClose = function handleClose() {
      setOpen(false);
    };

    var inProcess = (0, _reactRedux.useSelector)(_profile.selectInProcess);
    var wrapperRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isOpen = _useState2[0],
        setOpen = _useState2[1];

    (0, _react.useEffect)(function events() {
      function eventReset(event) {
        var selectElement = wrapperRef['current'];

        if (!selectElement) {
          return void 0;
        }

        if (!selectElement.contains(event['target'])) {
          handleClose();
        }
      }

      document.addEventListener('click', eventReset);
      return function () {
        document.removeEventListener('click', eventReset);
      };
    }, []);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      ref: wrapperRef,
      "data-locator": 'merchants'
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      "data-locator": 'merchants.logo',
      inProcess: inProcess,
      onClick: handleOpen
    }), isOpen && /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
      "data-locator": 'merchants.list',
      onClick: handleClose
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Widget;
exports["default"] = _default;